import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetDeceasedInformationSheetController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetDeceasedInformationSheetController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/information-sheet'
*/
const ElysGetDeceasedInformationSheetController = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysGetDeceasedInformationSheetController.url(args, options),
    method: 'get',
})

ElysGetDeceasedInformationSheetController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/elys/dossier/{dossier_id}/information-sheet',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetDeceasedInformationSheetController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetDeceasedInformationSheetController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/information-sheet'
*/
ElysGetDeceasedInformationSheetController.url = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            dossier_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        dossier_id: args.dossier_id,
    }

    return ElysGetDeceasedInformationSheetController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{dossier_id}', parsedArgs.dossier_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetDeceasedInformationSheetController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetDeceasedInformationSheetController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/information-sheet'
*/
ElysGetDeceasedInformationSheetController.get = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysGetDeceasedInformationSheetController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetDeceasedInformationSheetController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetDeceasedInformationSheetController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/information-sheet'
*/
ElysGetDeceasedInformationSheetController.head = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ElysGetDeceasedInformationSheetController.url(args, options),
    method: 'head',
})

export default ElysGetDeceasedInformationSheetController